import styled from "styled-components";

export const Container = styled.div`
  flex: 1;
  width: 100%;
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const Content = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  @media (min-width: 724px) {
    padding-top: 3rem
  }
`;

export const Form = styled.form`
  display: flex;
  gap: 2rem;
  max-width: 1280px;
  flex-direction: column;
  @media (min-width: 724px) {
    gap: 3rem;
  }
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const ParagraphContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  column-gap: 1.25rem;
  
  @media (min-width: 724px) {
    flex-direction: row
  }
`

export const SelectContainer = styled.div`
  @media (min-width: 724px) {
    width: 383px;
  }
`


export const InfoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 724px) {
    justify-content: flex-start;
  }
`

export const FileContainer = styled.div`
  display: flex;
  gap: 2rem;
  flex-direction: column;

  @media (min-width: 724px) {
    flex-direction: row;
  }
`

export const FileContent = styled.div``

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 4.5rem;
  margin-bottom: 2rem;

  @media (min-width: 724px) {
    margin-top: 6rem;
  }
`

export const FooterContainer = styled.div`
  display: flex;  
  align-items: center;
  justify-content: center;
  padding: 2rem;
  border-top: 1px solid ${({ theme }) => theme.colors.gray400};
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
`

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  width: 1280px;
  @media (min-width: 724px) {
    flex-direction: row;
  }
`

export const ToastContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-left: 0.75rem;
  border-left: 1px solid #f9b1b7;
  
`

export const ToastText = styled.span`
`
